import { ApolloProvider as Provider } from "@apollo/client";
import { useParams } from "@tanstack/react-router";
import { ReactNode, useMemo } from "react";
import { getApolloClient } from "./client";
import { useGetAccessToken } from "./getAccessToken";

type Props = {
  children: ReactNode;
};

export const ApolloProvider = ({ children }: Props) => {
  const { token } = useGetAccessToken();
  const { organizationSlug = "" } = useParams({ strict: false });

  const apolloClient = useMemo(() => {
    return getApolloClient(token, organizationSlug);
  }, [token, organizationSlug]);

  return <Provider client={apolloClient}>{children}</Provider>;
};
